import { forEach as each, bind, isUndefined } from 'lodash';

// Erik: I will admit this mixin confuses me. I'd prefer not to touch it much, and maybe just replace its functionality
// with Treadstone later.
var LeafletComponentMixin = {

  /**
   * A method to update based on props
   * @param props A map of props and their function to call to update it
   */
  updateProps: function (props, component) {
    var that = this;
    each(props, function (updateMethod, prop) {
      if (!isUndefined(that.props[prop])) {
        bind(updateMethod, that, component || that.component)();
      }
    });
  },

  componentDidMount: function () {
    // Erik: This was getting assigned with setState() earlier, which violates a seemingly important lint rule.
    // https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-did-mount-set-state.md
    // My workaround is to assign it directly to an object member variable, which is not following a nice React pattern,
    // but it should do no harm as it is not a state change intended to trigger a render. )And this whole class is
    // attempting to transcend the React pattern with Konstantinian Magicks anyhow.)
    this.component = this.generateComponent();
    this.addToMap(this.props.map, this.component);
    this.registerEventHandlers(this.component, this.props);

    // Run some setters if defined
    this.updateProps(this.updatableProps, this.component);
  },

  componentDidUpdate: function (oldProps) {
    this.updateProps(this.propUpdateMethods(oldProps));
  },

  componentWillUnmount: function () {
    if (this.componentWillRemoveFromMap) {
      this.componentWillRemoveFromMap(this.props.map);
    }

    if (this.component) {
      // order here is important! remove the layer first.
      this.props.map.removeLayer(this.component);
      this.unRegisterEventHandlers(this.component);
    }
  }
};

export default LeafletComponentMixin;
